import React from 'react';
import { useVideosList } from './presenter';
import { VideosListView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';
import { useConfirm } from '../../../components/ui/ConfirmDialog';
import { useToast } from '../../../components/ui/Toaster';

type Props = {
  navigate: (r: Route) => void;
};

const VideosIndexPage: React.FC<Props> = ({ navigate }) => {
  const vm = useVideosList();
  const confirm = useConfirm();
  const toast = useToast();

  return (
    <VideosListView
      data={vm.items}
      total={vm.total}
      page={vm.page}
      pageSize={vm.pageSize}
      setPage={vm.setPage}
      setPageSize={vm.setPageSize}
      query={vm.query}
      setQuery={vm.setQuery}
      loading={vm.loading}
      error={vm.error}
      onCreate={() => navigate({ name: 'videos/create' as any })}
      onView={id => navigate({ name: 'videos/view' as any, params: { id } as any })}
      onDelete={async id => {
        const ok = await confirm({ title: 'Delete Video', message: 'Are you sure you want to delete this video?', confirmText: 'Delete', variant: 'destructive' });
        if (!ok) return;
        await vm.remove(id);
        toast.success('Video deleted');
      }}
    />
  );
};

export default VideosIndexPage;
